var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"employee-warning-banner"},[_c('i',{staticClass:"icon sm rhg-font-icon--calendar"}),_c('div',{staticClass:"employee-warning-banner__text",attrs:{"data-testid":"employee-warning-banner-text"},domProps:{"innerHTML":_vm._s(_vm.translate('rdMemberNotificationTeamRateEmployee'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }